import { DropContainer } from "./DropContainer";
import { VBox } from "./Box";
import { classNames } from "../utils/classNames";
import { Icon } from "./Icon";
import { FileUploadConfig } from "../fileUpload/fileUploadDomain";
import { SelectFilesButton } from "./SelectFilesButton";
import { LoadingIndicator } from "./LoadingIndicator";

import { useTranslation } from "../stores/RootStoreContext";

export type UploadFilesPanelProps = {
  fileUploadConfig: FileUploadConfig;
  isUploading?: boolean;
  onUpload: (file: File[]) => void;
  multiple?: boolean;
};

export function UploadFilesPanel({
  fileUploadConfig,
  isUploading,
  onUpload,
  multiple,
}: UploadFilesPanelProps) {
  const { t } = useTranslation();
  return (
    <DropContainer onDrop={onUpload}>
      {({ active }) => (
        <VBox
          bg={active || isUploading ? "alt2" : "alt1"}
          border={active || isUploading ? "primary" : true}
          rounded
          padding
          className={classNames(
            "tw-text-center",
            (active || isUploading) && "tw-border-2 tw-border-dashed",
          )}
        >
          {isUploading ? (
            <LoadingIndicator size={"md"} />
          ) : active ? (
            <>
              <Icon name={"upload"} color={"info"} className={"tw-align-text-bottom"} />{" "}
              <strong>{t("upload-panel.drop-here-to-start-upload")}</strong>
            </>
          ) : (
            <>
              {t("upload-panel.drag-to-upload-or")}{" "}
              <SelectFilesButton
                className={"tw-align-middle tw-self-center"}
                variant={"link"}
                fileUploadConfig={fileUploadConfig}
                onChange={onUpload}
                multiple={multiple}
              />
            </>
          )}
        </VBox>
      )}
    </DropContainer>
  );
}
